<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 14:08:05
 * @FilePath: /privacy-web/src/views/PrivacyProtect/AuthoritativeCertification.vue
-->
<template>
  <div
    class="Authoritative-certification-main"
    :class="{ 'Authoritative-certification-main-mobile': isMobile }"
  >
    <!-- <div class="center"> -->
    <Base-title title="权威认证 值得信赖"></Base-title>
    <AuthoritativeCertificationContent></AuthoritativeCertificationContent>
    <!-- </div> -->
  </div>
</template>
<script>
export default {
  // 权威认证
  name: "AuthoritativeCertification",
};
</script>
<style lang="scss" scoped>
.Authoritative-certification-main {
  /* .center { */
  width: calc($multiple * 1040px);
  // height: calc($multiple * 600px);
  margin: 0 auto 72px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding-top: calc($multiple * 71px);
  flex-direction: column;
  /* } */
}
.Authoritative-certification-main-mobile {
  /* .center { */
  width: auto;
  margin: auto;
  border-radius: 3px;
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 2.4rem;
  flex-direction: column;
  /* } */
}
</style>
